import { PortalNoteTemplate, TileType } from '@nx-frontend/shared/types';

export function getNoteTemplateIdFromTile(tileType: TileType): PortalNoteTemplate {
  switch (tileType) {
    case TileType.ONBOARDING:
      return 'onboarding';
    case TileType.WELCOME_PAGE:
      return 'welcome-page';
    case TileType.KANBAN:
      return 'board';
    case TileType.TASK_LIST:
      return 'task-list';
    case TileType.FAQ:
      return 'faq';
    case TileType.FLOW_GUIDES:
      return 'flow-guides';
    default:
      throw new Error('Invalid TileType');
  }
}
